import { subscriptionsInfo } from "../../../shared-data";

export const getSubscriptionChange = ({
  providedPrice,
  itemsConfig,
  currentPrice,
}) => {
  if (currentPrice === providedPrice) {
    return itemsConfig.active;
  } else if (providedPrice > currentPrice) {
    return itemsConfig.upgrade;
  } else {
    return itemsConfig.downgrade;
  }
};

export const getSubscriptionsToDisplay = ({
  accountType,
  subscriptionType,
}) => {
  const arr = subscriptionsInfo[accountType].content;

  let filteredArr = arr.filter(
    (item) => !(item.hidden && item.type !== subscriptionType),
  );

  return Object.values(
    filteredArr.reduce((acc, item) => {
      const key = item.premium ? "premium" : "regular";
      if (!acc[key] || item.type === subscriptionType) {
        acc[key] = acc[key] || [];
        acc[key].push(item);
      }
      return acc;
    }, {}),
  ).flat();
};
